import React from 'react';

import {
  Typography,
  Link,
  IconButton,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  EditIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import AffiliateDetails from 'scenes/Affiliates/components/AffiliateDetails';
import { AffiliateFormEdit } from 'scenes/Affiliates/components/AffiliateForm';

const AffiliatesSection = ({ affiliates = [] }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  return affiliates ? (
    <React.Fragment>
      <TableContainer>
        <Table width={'100%'}>
          <TableBody>
            {affiliates.map((row) => {
              const handleOpenAffiliates = async () => {
                openChildComponent(AffiliateDetails, {
                  id: row.id,
                });
              };

              const handleEditAffiliates = async () => {
                openChildComponent(AffiliateFormEdit, {
                  id: row.id,
                });
              };

              return (
                <TableRow key={row.id}>
                  <TableCell>
                    <Typography variant={'body2'}>
                      <Link onClick={handleOpenAffiliates}>{row.name}</Link>
                    </Typography>
                  </TableCell>
                  <TableCell align={'right'} padding={'actions'}>
                    <IconButton
                      icon={<EditIcon />}
                      tooltip={'Edit Affiliate'}
                      onClick={handleEditAffiliates}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {childComponent}
    </React.Fragment>
  ) : null;
};

export default AffiliatesSection;
